export const walletStatusConstants = {
  GET_WALLETSTATUS_REQUEST: "GET_WALLETSTATUS_REQUEST",
  GET_WALLETSTATUS_SUCCESS: "GET_WALLETSTATUS_SUCCESS",
  GET_WALLETSTATUS_FAILURE: "GET_WALLETSTATUS_FAILURE",
  GET_WALLETSTATUS_RESET: "GET_WALLETSTATUS_RESET"
};
